import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _loading = new BehaviorSubject<boolean>(true);
  loading$ = this._loading.asObservable();
  private timeout: any;
  private minDuration = 300;
  private startTime = 0;

  show() {
    clearTimeout(this.timeout);
    this.startTime = Date.now();
    this._loading.next(true);
  }

  hide() {
    const elapsed = Date.now() - this.startTime;
    const remaining = Math.max(this.minDuration - elapsed, 0);

    this.timeout = setTimeout(() => {
      this._loading.next(false);
    }, remaining);
  }
}